import { FaBook, FaCreditCard, FaGraduationCap } from "react-icons/fa";
import "./educate.css";
import RegisterTwo from "../../components/registertwo";

const Educate = () => {
  return (
    <section className="educate-section">
      {/* Contenido principal centrado */}
      <div className="container text-center educate-main">
        <div className="educate-title-container">
          <h1 className="display-4">EDUCACIÓN</h1>
          <p className="lead">
            Recursos para desarrollar tus habilidades y crecer profesionalmente.
          </p>
        </div>

        <div className="row g-4 mb-4">
          {/* Guía Educativa */}
          <div className="col-12 col-md-4">
            <div className="card educate-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaBook className="icon" />
                </div>
                <h2 className="educate-card-title">Guía Educativa</h2>
                <p className="text-muted">
                  Aprende con recursos prácticos y orientados a tu éxito.
                </p>
              </div>
            </div>
          </div>
          {/* Validación de Crédito */}
          <div className="col-12 col-md-4">
            <div className="card educate-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaCreditCard className="icon" />
                </div>
                <h2 className="educate-card-title">Validación de Crédito</h2>
                <p className="text-muted">
                  Conoce tus opciones y mejora tu perfil crediticio.
                </p>
              </div>
            </div>
          </div>
          {/* Ofertas Educativas */}
          <div className="col-12 col-md-4">
            <div className="card educate-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaGraduationCap className="icon" />
                </div>
                <h2 className="educate-card-title">Ofertas Educativas</h2>
                <p className="text-muted">
                  Descubre oportunidades de formación y becas.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <button className="btn btn-warning">
            EXPLORA NUESTROS PROGRAMAS DE EDUCACIÓN
          </button>
        </div>
      </div>

      {/* Componente de registro full width */}
      <RegisterTwo />
    </section>
  );
};

export default Educate;